import React from "react"
import Step from "./Step"
import {useTranslation} from "next-i18next"
import PropTypes from "prop-types"
import {useRouter} from "next/router"

type Props = {
    activeStep?: number
}

export const StepsIndicatorCircle: React.FC<Props> = ({activeStep}) => {
	const {t} = useTranslation()
	const router = useRouter()
	return (
		<div className={"row justify-content-center"}
			style={{
				height: 64
			}}>
			<div className={"col-10 col-md-8 col-lg-6 col-xl-4"}>
				<div className={"row g-0 align-items-center"}>
					<div className={"col-auto pointer"}
						onClick={async () => {
							await router.push(t("/checkout"))
						}}>
						<Step number={1}
							label={t("Dauer")}
							active={activeStep >= 1}
							past={activeStep > 1}/>
					</div>
					<div className={`col border-top border-2 ${activeStep > 1 ? "border-success" : null}`}/>
					<div className={"col-auto pointer"}
						onClick={() => {
							router.push(t("/checkout/meine-angaben"))
						}}>
						<Step number={2}
							label={t("Kontaktangaben")}
							active={activeStep >= 2}
							past={activeStep > 2}/>
					</div>
					<div className={`col border-top border-2 ${activeStep > 2 ? "border-success" : null}`}/>
					<div className={"col-auto"}>
						<Step number={3}
							label={t("Bestätigung")}
							active={activeStep >= 3}
							past={activeStep > 3}/>
					</div>
				</div>
			</div>
		</div>
	)
}

StepsIndicatorCircle.propTypes = {
	activeStep: PropTypes.number
}

